/**
 * Человекочитаемый URL для UI: %D1%80… → кириллица.
 * Для href оставляй исходную (закодированную) строку.
 */
export function displayReadableUrl(url: string): string {
  if (!url) return "";
  let out = String(url);
  for (let i = 0; i < 2; i++) {
    if (!/%[0-9A-Fa-f]{2}/.test(out)) break;
    try {
      out = decodeURI(out);
    } catch {
      try {
        out = decodeURIComponent(out);
      } catch {
        break;
      }
    }
  }
  return out;
}

/** Декод текста из OG (title/description), в т.ч. slug целиком в %XX */
export function displayReadableText(text: string): string {
  if (!text) return "";
  let out = String(text).trim();
  for (let i = 0; i < 3; i++) {
    if (!/%[0-9A-Fa-f]{2}/.test(out)) break;
    try {
      out = decodeURIComponent(out);
    } catch {
      try {
        out = decodeURI(out);
      } catch {
        break;
      }
    }
  }
  return out;
}

/** Мусорный OG title (SSO / login wall / hash id) */
export function isGarbageOgTitle(s: string): boolean {
  if (!s) return true;
  const t = s.trim();
  if (t.length < 2) return true;
  if (/%[0-9A-Fa-f]{2}/.test(t)) return true;
  if (/^push\?/i.test(t)) return true;
  if (/retpath=/i.test(t)) return true;
  if (/passport\.|\/sso|\/login|\/signin|auth\?/i.test(t)) return true;
  if (/^[a-f0-9]{16,}$/i.test(t)) return true; // dzen/youtube-like id
  if (!/\s/.test(t) && (t.match(/-/g) || []).length >= 4 && t.length > 40) {
    return true;
  }
  return false;
}

/** Заголовок из URL, если OG пустой / SSO / slug */
export function titleFromUrl(url: string): string {
  try {
    const u = new URL(url);
    const host = u.hostname.replace(/^www\./, "");
    const path = u.pathname.replace(/\/+$/, "");

    if (
      /\/video\//i.test(path) ||
      /youtu\.be|youtube\.|dzen\.ru|rutube\.|vimeo\./i.test(host)
    ) {
      return `Video · ${host}`;
    }
    if (/\/watch/i.test(path)) {
      return `Video · ${host}`;
    }

    const parts = path.split("/").filter(Boolean);
    const slug = displayReadableText(
      decodeURIComponent(parts[parts.length - 1] || "")
    );
    if (
      slug &&
      slug.length > 2 &&
      !/^index\.(html?|php)$/i.test(slug) &&
      !isGarbageOgTitle(slug)
    ) {
      return slug.replace(/[-_]+/g, " ").replace(/\s+/g, " ").trim();
    }
    return host || displayReadableUrl(url);
  } catch {
    return displayReadableUrl(url);
  }
}

export function hostnameFromUrl(url: string): string {
  try {
    return new URL(url).hostname.replace(/^www\./, "");
  } catch {
    return "";
  }
}
